module.exports = __webpack_public_path__ + "img/service-jiaoyicuohe1.e90adb28.svg";